import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Renders SEO meta tags + optional JSON-LD schema for a page.
 * @param {Object} p
 * @param {string} p.title
 * @param {string} p.description
 * @param {string} p.keywords
 * @param {string} p.image
 * @param {string} p.canonical
 * @param {object} p.jsonLd - JSON-LD object (or array)
 */
const Seo = ({ title, description, keywords, image, canonical, jsonLd }) => (
  <Helmet>
    {title && <title>{title}</title>}
    {description && <meta name="description" content={description} />}
    {keywords && <meta name="keywords" content={keywords} />}
    {canonical && <link rel="canonical" href={canonical} />}
    {title && <meta property="og:title" content={title} />}
    {description && <meta property="og:description" content={description} />}
    {image && <meta property="og:image" content={image} />}
    <meta name="twitter:card" content="summary_large_image" />
    {title && <meta name="twitter:title" content={title} />}
    {description && <meta name="twitter:description" content={description} />}
    {image && <meta name="twitter:image" content={image} />}
    {jsonLd && (
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    )}
  </Helmet>
);

export default Seo;
